var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectMiniCard',{attrs:{"id":(_vm.id + "-selectBoolean"),"label":_vm.label,"value":this.value,"options":_vm.booleanOptions},on:{"handleChangeSelect":_vm.handleChangeSelect}})}
var staticRenderFns = []

export { render, staticRenderFns }